import { Modal, Button } from "react-bootstrap";
import { useState } from "react";
import Icon from "../Icon";
import { FormattedMessage } from 'react-intl';

const Modszer = ({ publication, modszer, theme, mode }) => {
  const [lgShow, setLgShow] = useState(false);

  const addClass = () => {
    if (mode === "dark") {
      //document.querySelectorAll(".modal-body h2").forEach((e) => e.classList.add("theme-color"))
      document.querySelectorAll(".modal-body h1").forEach((e) => e.classList.add("theme-color"))
    }
  }
  return (<>
    <Button
      onClick={() => setLgShow(true)}
      className={`modszertan button`}>
      <Icon icon="modszertan" className={"white"} />
      <FormattedMessage id="methodology" defaultMessage="Módszertan" />
    </Button>
    <Modal
      size="lg"
      show={lgShow}
      onHide={() => setLgShow(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      onShow={addClass}
      centered
    >
      <Modal.Header closeButton  className={theme ? theme.url : "notheme"} >
        <Modal.Title id="example-modal-sizes-title-lg">
          <Icon icon="modszertan" className="white" /> <FormattedMessage id="methodology" defaultMessage="Módszertan" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={theme ? theme.url : "notheme"} dangerouslySetInnerHTML={{ __html: modszer }}></Modal.Body>
    </Modal>
  </>)
}

export default Modszer;
